import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./LiveClassDetail.css";

const LiveClassDetail = () => {
  const navigate = useNavigate();
  const [liveClassDetail, setLiveClassDetail] = useState({});
  const { liveClassId } = useParams();
  console.log(liveClassId);

  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/live-classes/${liveClassId}`)
      .then((response) => {
        const data = response.data?.data;
        console.log(data);

        setLiveClassDetail(data);
      })
      .catch((error) => console.log(error));
  }, [API_BASE_URL]);

  console.log(liveClassDetail);

  return (
    <div id="add-subject-inner-wrapper">
      <div className="superheader">
        <div className="subjectHeaderdiv">
          <h5>Live Classes</h5>
          <div className="subjectdiv2">
            <button
              className="handleNewSubject"
              onClick={() => navigate("/live-class-add")}
            >
              + Add New Live Class
            </button>
            <button
              className="allSubjects"
              onClick={() => navigate("/live-class-list")}
            >
              All Live Class
            </button>
          </div>
        </div>

        {/* <div className="form-sub-container mt-4" id="form">
          <h4 className="subject-detail">Live Class Details</h4>
          <div>
            Thumbnail :{" "}
            <img
              src={`${API_BASE_URL}/uploads/${liveClassDetail.thumbnail}`}
              alt=""
              className="liveClassImg"
            />
          </div>
          <div>Title : {liveClassDetail.title}</div>
          <div>Description : {liveClassDetail.description}</div>
          <div>
            Teachers :{" "}
            {liveClassDetail.teacherName &&
              liveClassDetail.teacherName.map((teacher, idx) => (
                <div key={idx}>{teacher}</div>
              ))}
          </div>
          <div>Price : {liveClassDetail.price}</div>
        </div> */}

        <div className="container mt-4" id="form">
          <div className="card">
            <div className="card-header">
              <h1 className="mb-0">Live Class Details</h1>
            </div>
            <div className="card-body">
              <div className="mb-3">
                <h4>
                  <strong>Thumbnail:</strong>
                </h4>
                <img
                  src={`${API_BASE_URL}/uploads/${liveClassDetail.thumbnail}`}
                  alt="Live Class Thumbnail"
                  className="img-fluid mt-2 rounded"
                  style={{ maxWidth: "300px", marginLeft: "10%" }}
                />
              </div>
              <div className="mb-2 fs-4">
                <strong>Title:</strong> {liveClassDetail.title}
              </div>
              <div className="mb-2 fs-4">
                <strong>Description:</strong> {liveClassDetail.description}
              </div>
              <div className="mb-3 fs-4 d-flex justify-content-start gap-2">
                <strong>Teachers:</strong>
                <div className="">
                  {liveClassDetail.teacherName &&
                    liveClassDetail.teacherName.map((teacher, idx) => (
                      <span key={idx}>{teacher} ,</span>
                    ))}
                </div>
              </div>
              <div className="fs-4">
                <strong>Price:</strong> {liveClassDetail.price}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LiveClassDetail;
